import React from "react"
import { useHistory } from 'react-router-dom';
import Modal from "../UI/Modal"

const ThankYouContactUs = (props) => {

    const history = useHistory()

    const handleClose = () => {
        props.onClose()
        history.replace('/')
    }
    return (
      <Modal>
        <div className="thanksMsgHolder h-full sm:h-full md:h-screen flex grow mx-0 sm:mx-4">
          <div className="thanksMsgBg flex items-stretch justify-normal h-screen landscape:h-auto sm:h-auto sm:landscape:h-auto rounded-none sm:rounded-lg sm:max-w-[1162px] max-w-full max-h-full  sm:max-h-[620px] md-h-[620px] m-auto bg-white relative px-10 py-8 grow">
            {/* {isLoading && (
            <div className="parentDisable">
              <LoadingSpinner />
            </div>
          )} */}
            <div className="w-full flex flex-col gap-10">
              <div className="thanksMsgHeaderAndBody flex flex-col h-full gap-6 basis-full overflow-auto">
                <div className="thanksMsgHeader flex justify-between items-center gap-6">
                  <h2 className="pageTitle  text-[#354665] barlowBold text-base  sm:text-xl uppercase">
                    Thank you
                  </h2>
                </div>
                <div className="thanksMsgBody basis-full overflow-auto">
                  <div className="thanksMsgBodyContent">
                    <div className="p-5 b border border-[#D9D9D9] bg-[#FCFCFC] flex flex-col gap-4 !*:text-[#333] !*:font-normal !*:tex-sm !*:leading-5 !*:sm:text-base !*:md:text-xl !*:md:leading-7">
                      {/* <p className="">Thanks for subscribing</p> */}
                      {props.popUpConsent ? (
                        <div
                          className="dynamicContentList"
                          dangerouslySetInnerHTML={{
                            __html: props.popUpConsent,
                          }}
                        ></div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="thanksMsgFooter flex  items-end">
                <div className="thanksMsgActions flex max-[420px]:flex-wrap  sm:flex-nowrap gap-4 sm:gap-5 grow *:min-w-[154px] *:max-[420px]:w-full">
                  <div className="buttonHolder" onClick={handleClose}>
                    <button className="btn submitBtn w-fit bg-primaryBlue h-[46px] px-5 py-[10px] font-bold leading-5 text-base justify-center  rounded text-white inline-flex items-center min-w-[140px]">
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
}

export default ThankYouContactUs